const setupAccordion = () => {
  const submenuTitles = document.querySelectorAll('.submenu-title');

  submenuTitles.forEach((title) => {
    title.addEventListener('click', () => {
      if (window.innerWidth < 700) {
        title.classList.toggle('expanded');

        const ul = title.parentElement;

        if (ul) {
          ul.classList.toggle('expanded');
        }
      }
    });
  });
};
document.addEventListener('DOMContentLoaded', function () {
  setupAccordion();

  window.addEventListener('resize', () => {
    const submenuTitles = document.querySelectorAll('.submenu-title');
    submenuTitles.forEach((title) => {
      const newTitle = title.cloneNode(true);
      title.parentNode.replaceChild(newTitle, title);
    });

    setupAccordion();
  });
});
